import React, { useEffect, useState } from 'react';

import { Input, Label, UncontrolledTooltip } from 'reactstrap';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { validation } from '../../../../utils/helpers/masks/validations';
import { paisesPt } from '../../../../utils/helpers/data/countries';

export default function CellphoneDisplay({ attributes, rowId, colId, setValue }) {
  // Valor formatado (ex: "+55 11 99999-9999") — inicializa com
  // attributes.value pra suportar pré-preenchimento no PublicTemplate.
  const [phone, setPhone] = useState(attributes.value || '');

  // FIX_SSR — o PhoneInput depende de useEffect internamente e não roda em
  // SSR (renderToString do editor de templates). No primeiro render mostramos
  // um <Input> básico com placeholder "+55" só como espelho visual; após o
  // useEffect o widget real assume no browser.
  const [ssr, setSsr] = useState(true);
  useEffect(() => {
    setSsr(false);
  }, []);

  useEffect(() => {
    const html = attributes.label;
    const div = document.getElementsByClassName(`cellphone-label-${rowId}-${colId}`);

    for (const element of div) {
      element.innerHTML = html + (attributes.required ? '*' : '');
    }
  }, [attributes, rowId, colId]);

  useEffect(() => {
    // O PhoneInput preenche "+55" (prefixo do país default) no mount, sem
    // interação do usuário. Consideramos como "vazio" enquanto o total de
    // dígitos for menor que o mínimo pra um número real. Isso:
    //  - Impede o inline "Celular incompleto" aparecer antes de digitar.
    //  - Faz o value ficar "" no state (o filter do payload exclui — não
    //    envia "+55" cru).
    const digits = (phone || "").replace(/\D/g, "");
    const hasRealValue = digits.length >= 3;

    setValue((oldValue) => {
      const newValue = [...oldValue];
      newValue[rowId].cols[colId].attributes.value = hasRealValue ? phone : "";

      if (!hasRealValue) {
        // Se o campo é obrigatório, marca errorMessage sem useRawErrorMessage.
        // Isso mantém o inline "silencioso" enquanto o usuário não interage
        // mas garante que o handleSubmit detecte o campo vazio (o FormMounted
        // exibe a mensagem só após tentar enviar quando required=true).
        newValue[rowId].cols[colId].attributes.errorMessage = attributes.required
          ? "Campo obrigatório"
          : "";
        newValue[rowId].cols[colId].attributes.useRawErrorMessage = false;
        return newValue;
      }

      const { isValid, message } = validation(phone, "cellphone");
      newValue[rowId].cols[colId].attributes.errorMessage = !isValid
        ? message
        : "";
      newValue[rowId].cols[colId].attributes.useRawErrorMessage = !isValid;
      return newValue;
    });
  }, [phone, setValue, rowId, colId, attributes.required]);

  return (
    <div>
      <div className="custom-input-container">
        <div className="displayed-config-container">
          <div className="displayed-label">
            {/* FIX_SSR_LABEL */}
            <Label
              htmlFor="formText"
              className={`form-label cellphone-label-${rowId}-${colId}`}
              style={{ display: "inline", marginRight: 2 }}
            >
              {attributes.label}
            </Label>
            {attributes.hasTip && (
              <div>
                <div className="show-tips" id={`cell-disp-tip-${rowId}-${colId}`}>
                  <span>?</span>
                </div>
                <UncontrolledTooltip style={{ backgroundColor: '#6f42c1' }} placement="right" target={`cell-disp-tip-${rowId}-${colId}`}>
                  {attributes.tipText}
                </UncontrolledTooltip>
              </div>
            )}
          </div>
        </div>
        {ssr ? (
          <Input
            className="form-control"
            type="text"
            id="formText"
            placeholder={attributes.placeholder || '+55'}
            defaultValue={phone}
            readOnly
          />
        ) : (
          <PhoneInput
            defaultCountry="br"
            value={phone}
            onChange={(value) => setPhone(value)}
            countries={paisesPt}
            inputStyle={{ width: '100%' }}
            disabled={!!attributes.readOnly}
          />
        )}
      </div>
    </div>
  )
}
